import { calcPct } from './awardScoring';
import { normalizeName } from './lib/nameMatching';

// Ray and Bass Hunt (month-long shore comp, 1st–31st October):
// best combined CFSA % of one ray (any species) and one bass.

export function huntDateRange(year) {
  return { start: `${year}-10-01`, end: `${year}-10-31` };
}

// The admin "Entered into Ray and Bass Hunt" box only applies to shore fish weighed in October.
export function canEnterRayBassHunt(location, weighDate) {
  return location === 'shore' && /^\d{4}-10-/.test(weighDate || '');
}

// The home and Awards pages show the hunt from 1st October until 10 days after it ends (10th November).
export function isRayBassHuntActive(date = new Date()) {
  const month = date.getMonth(); // 0 = Jan
  return month === 9 || (month === 10 && date.getDate() <= 10);
}

// The hunt shown by default: this year's once October arrives, otherwise last year's result.
export function defaultHuntYear(now = new Date()) {
  return now.getMonth() >= 9 ? now.getFullYear() : now.getFullYear() - 1;
}

function huntCategory(species) {
  const s = String(species || '').trim();
  if (/^ray\b/i.test(s)) return 'ray';
  if (/^bass$/i.test(s)) return 'bass';
  return null;
}

function isEligible(c, year) {
  const { start, end } = huntDateRange(year);
  return c.location === 'shore'
    && c.in_ray_bass_hunt === true
    && c.weigh_date >= start
    && c.weigh_date <= end
    && huntCategory(c.species) != null;
}

// Returns one entry per angler, ranked. Anglers with both a ray and a bass rank
// above those still missing one; ties share a rank.
export function buildRayBassLeaderboard(catches, year) {
  const byAngler = new Map();

  catches.filter((c) => isEligible(c, year)).forEach((c) => {
    // Capped at 150% per fish, as for the Bream Competition.
    const pct = calcPct(c.species, 'shore', c.weight_kg, 's', 150) || 0;
    const key = normalizeName(c.angler_name);
    if (!byAngler.has(key)) byAngler.set(key, { angler: c.angler_name.trim(), ray: null, bass: null });
    const entry = byAngler.get(key);
    const category = huntCategory(c.species);
    if (!entry[category] || pct > entry[category].pct) entry[category] = { ...c, pct };
  });

  const entries = Array.from(byAngler.values()).map((e) => ({
    ...e,
    complete: Boolean(e.ray && e.bass),
    total: (e.ray?.pct || 0) + (e.bass?.pct || 0),
  }));

  entries.sort((a, b) => (b.complete - a.complete) || (b.total - a.total));

  entries.forEach((e, i) => {
    const prev = entries[i - 1];
    e.rank = prev && prev.complete === e.complete && prev.total === e.total ? prev.rank : i + 1;
  });

  return entries;
}
